enum API_PATHS {
  api = '/api.plx',
  avatar = '/get_avatar.plx',
  playerInfo = '/playerinfo.plx',
  corner = '/corner.plx',
  stripe = '/stripe_prepare.plx',
  amazon = '/azs.plx',
  ladder = '/ladder.plx',
  standings = '/lstandings.plx',
  ranked = '/lspot.plx',
  statement = '/lpstatement.plx',
  challenge = '/challenge.plx',
  stats = '/statrd.plx',
  lostPassword = '/lostpwd.plx',
  tourneyStats = '/trnstat.plx',
  calc = '/calc.plx',
  contactus2 = '/contactus2.plx',
  forum = '/forumapi.plx',
  findPlayer = '/findplayer.plx',
  gameview = '/gameview.plx'
}

export default API_PATHS;
